const { queryParser } = require('gui');
const transporters = require('../../transporters.js');

function logoPresenter() {
	const c = {};
	const view = require('./logoPresenter.tpl.html');
	const customerCode = queryParser.get('id') || 'tim';
	const transporter = transporters[customerCode.toLowerCase()];

	c.activate = function(region){
		if (!transporter)
			return;
		var logoElement = view.image;
		logoElement.style.backgroundImage = `url(img/${transporter.img})`;
		if (transporter.url){
			logoElement.href = transporter.url;
		}

		view.activate(region);
	};

	return c;
}

module.exports = logoPresenter;